import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKx10015BuExportStatus: 'idle',
    startProcessKx10015BuExportError: undefined as any,
    loadUserParamsProcessKx10015BuExportStatus: 'idle',
    loadUserParamsProcessKx10015BuExportError: undefined as any,
    schnstIni_Kx570b2EditLaufNrStatus: 'idle',
    schnstIni_Kx570b2EditLaufNrError: undefined as any,

    processKx10015BuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    schnstIni_Kx570b2EditLaufNr: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKx10015BuExport = createAsyncThunk('processKx10015BuExportSlice/startProcessKx10015BuExport', async ({ processKx10015BuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKx10015BuExport/`,
        prepareData(processKx10015BuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKx10015BuExportStatus } = getState().processKx10015BuExportSlice
        return startProcessKx10015BuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKx10015BuExport = createAsyncThunk('processKx10015BuExportSlice/loadUserParamsProcessKx10015BuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKx10015BuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKx10015BuExportStatus } = getState().processKx10015BuExportSlice
        return loadUserParamsProcessKx10015BuExportStatus !== 'pending'
    }
})

export const schnstIni_Kx570b2EditLaufNr = createAsyncThunk('processKx10015BuExportSlice/schnstIni_Kx570b2EditLaufNr', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/SchnstIni_Kx570b2EditLaufNr/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { schnstIni_Kx570b2EditLaufNrStatus } = getState().processKx10015BuExportSlice
        return schnstIni_Kx570b2EditLaufNrStatus !== 'pending'
    }
})

const ProcessKx10015BuExportSlice = createSlice({
    name: 'processKx10015BuExportSlice',
    initialState,
    reducers: {
        resetstartProcessKx10015BuExport: (state) => {
            state.job = undefined
            state.startProcessKx10015BuExportError = undefined
        },
        resetstartProcessKx10015BuExportError: (state) => {
            state.startProcessKx10015BuExportError = undefined
        },
        resetloadUserParamsProcessKx10015BuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKx10015BuExportError = undefined
        },
        resetloadUserParamsProcessKx10015BuExportError: (state) => {
            state.loadUserParamsProcessKx10015BuExportError = undefined
        },
        resetschnstIni_Kx570b2EditLaufNr: (state) => {
            state.schnstIni_Kx570b2EditLaufNr = undefined
            state.schnstIni_Kx570b2EditLaufNrError = undefined
        },
        resetschnstIni_Kx570b2EditLaufNrError: (state) => {
            state.schnstIni_Kx570b2EditLaufNrError = undefined
        },
        removeFromProcessKx10015BuExportListById: (state, action) => {
            state.processKx10015BuExportList = state.processKx10015BuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKx10015BuExportListByIds: (state, action) => {
            state.processKx10015BuExportList = state.processKx10015BuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKx10015BuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKx10015BuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKx10015BuExportList = []
            state.startProcessKx10015BuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKx10015BuExport.pending, (state) => {
            state.startProcessKx10015BuExportStatus = 'pending'
            state.startProcessKx10015BuExportError = undefined
        })
        builder.addCase(startProcessKx10015BuExport.fulfilled, (state, action) => {
            state.startProcessKx10015BuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKx10015BuExport.rejected, (state, action) => {
            state.startProcessKx10015BuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKx10015BuExportError = action.error.message
            } else {
                state.startProcessKx10015BuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKx10015BuExport.pending, (state) => {
            state.loadUserParamsProcessKx10015BuExportStatus = 'pending'
            state.loadUserParamsProcessKx10015BuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKx10015BuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKx10015BuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKx10015BuExport.rejected, (state, action) => {
            state.loadUserParamsProcessKx10015BuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKx10015BuExportError = action.error.message
            } else {
                state.loadUserParamsProcessKx10015BuExportError = action.payload
            }
        })

        builder.addCase(schnstIni_Kx570b2EditLaufNr.pending, (state) => {
            state.schnstIni_Kx570b2EditLaufNrStatus = 'pending'
            state.schnstIni_Kx570b2EditLaufNrError = undefined
        })
        builder.addCase(schnstIni_Kx570b2EditLaufNr.fulfilled, (state, action) => {
            state.schnstIni_Kx570b2EditLaufNrStatus = 'idle'

            {
                state.schnstIni_Kx570b2EditLaufNr = action.payload

            }
        })
        builder.addCase(schnstIni_Kx570b2EditLaufNr.rejected, (state, action) => {
            state.schnstIni_Kx570b2EditLaufNrStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.schnstIni_Kx570b2EditLaufNrError = action.error.message
            } else {
                state.schnstIni_Kx570b2EditLaufNrError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKx10015BuExport,
    resetstartProcessKx10015BuExportError,
    resetloadUserParamsProcessKx10015BuExport,
    resetloadUserParamsProcessKx10015BuExportError,
    resetschnstIni_Kx570b2EditLaufNr,
    resetschnstIni_Kx570b2EditLaufNrError,
    removeFromProcessKx10015BuExportListById,
    removeFromProcessKx10015BuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKx10015BuExportSlice.actions
export default ProcessKx10015BuExportSlice.reducer
